<template>
  <div>
    <div
      :class="`empty type${$route.query.type}`"
      v-if="loading && qaList?.length === 0"
    >
      <div class="skeleton"></div>
    </div>
    <div class="qaList" v-else>
      <div class="activity-header-container">
        <div
          class="activity-header"
          :style="{
            paddingTop: stateHeight,
            background: bgColor,
          }"
        >
          <van-nav-bar :border="false" class="navbar" placeholder>
            <template #left>
              <div class="left">
                <img
                  class="icon-back"
                  src="../assets/img/activity/icon-back.png"
                  @click="handleBack"
                />
              </div>
            </template>
          </van-nav-bar>
        </div>
      </div>
      <div
        class="qaList_content_wrap"
        :style="{
          paddingTop: parseInt(stateHeight) + 48 + 'px',
        }"
      >
        <div class="qaList_header" v-if="queryData?.type == '1'">
          <img src="@/assets/img/activity/qabg1@3x.png" alt="" />
          <div>
            <img src="@/assets/img/activity/header_avatar@3x.png" alt="" />
            <span>共{{ totalCount }}个问答</span>
          </div>
        </div>
        <template v-else-if="queryData?.type == '2'">
          <CompanyCard :coInfo="coInfo" :jobSource="queryData?.jobSource" />
          <div class="answer_num">共{{ totalCount }}个问答</div>
        </template>
        <template v-else>
          <JobCard :jobInfo="jobInfo" />
          <div class="answer_num">共{{ totalCount }}个问答</div>
        </template>
        <div class="empty_div_wrap" v-if="!loading && qaList?.length === 0">
          <Empty text="暂无问答" />
        </div>
        <van-list
          v-else
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :error.sync="jobError"
          loading-text="正在加载…"
          finished-text="暂时没有更多了～"
          error-text="请求失败，点击重新加载"
          @load="getQuestionList"
        >
          <template>
            <div
              v-for="(item, index) in qaList"
              :key="index"
              class="sensors_exposure"
              sensorsname="PostExposure"
              :sensorsdata="JSON.stringify(item.sensorsdata)"
            >
              <QaCard :itemData="item" page="列表页" :type="queryData?.type" />
            </div>
          </template>
        </van-list>
      </div>
      <div class="bottom_btn">
        <div @click="toQuestion">我也要提问</div>
      </div>
    </div>
  </div>
</template>
<script>
import CompanyCard from "@/components/common/CompanyCard.vue";
import QaCard from "@/components/common/qaCard.vue";
import JobCard from "@/components/common/JobCard.vue";
import Empty from "@/components/common/EmptyData.vue";
export default {
  name: "QuestionAndAnswerList",
  components: {
    CompanyCard,
    QaCard,
    JobCard,
    Empty,
  },
  data() {
    return {
      loading: true,
      finished: false,
      jobError: false,
      pageNum: 1,
      totalCount: 0,
      qaList: [],
      stateHeight: 0,
      bgColor: "",
      coInfo: {},
      jobInfo: {},
      queryData: this.$route.query || {},
    };
  },
  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 0) {
        this.bgColor = "linear-gradient( 180deg, #F9EBE1 0%, #F8F2EE 100%)";
      } else {
        this.bgColor = "";
      }
    },
    handleBack() {
      const sessionData = sessionStorage.getItem(this.queryData.activityId);
      const { func, city } = sessionData ? JSON.parse(sessionData) : {};
      this.$router.push({
        path: `/op/${this.queryData.activityId}`,
        query: {
          func,
          city,
        },
      });
    },
    toQuestion() {
      if (!this.$base.checkLoginStatus(true)) return;
      const { type, activityId, componentId, id, jobSource } = this.queryData;
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_qalist_ask",
        companyId: type == "2" ? id : this.jobInfo?.coId,
        jobId: type == "3" ? id : undefined,
      });
      const extrParams = {
        2: {
          coId: id,
          coName: this.coInfo.companyName,
          ctmId: this.coInfo.ctmId,
          jobSource,
        },
        3: {
          jobId: id,
          coId: this.jobInfo.coId,
          jobName: this.jobInfo.jobName,
          provideSalaryString: this.jobInfo.provideSalaryString,
          coName: this.jobInfo.fullCompanyName,
          ctmId: this.jobInfo.ctmId,
        },
      };
      this.$router.push({
        path: "/askQuestion",
        query: {
          activityId,
          type,
          componentId,
          ...extrParams[type],
        },
      });
    },
    async getQuestionList() {
      if (this.finished) return;
      const { type, id, componentId } = this.queryData;
      const extrParams = {
        1: {
          sortType: [3, 2, 1],
        },
        2: {
          coIdList: [id],
          sortType: [2, 1],
        },
        3: {
          jobIdList: [id],
          sortType: [2, 1],
        },
      };
      const params = {
        componentId,
        pageSize: 10,
        pageNum: this.pageNum,
        type,
        ...extrParams[type],
      };
      const res = await this.$api.activity.queryQuestionList(params);
      if (+res?.code == "0" && res?.data) {
        const { questionMap = {} } = res.data || {};
        const { questionInfoList, totalCount, totalPages } =
          questionMap[id] || {};
        const result = questionInfoList || [];
        const newResult = result.map((item, index) => {
          return {
            ...item,
            sensorsdata: {
              companyId:
                this.queryData?.type == "2"
                  ? this.coInfo?.coId
                  : this.queryData?.type == "3"
                  ? this.jobInfo?.coId
                  : item?.companyInfo?.coId || item?.jobInfo?.coId,
              jobId:
                this.queryData?.type == "3"
                  ? this.jobInfo?.jobId
                  : item.jobInfo?.jobId,
              contentId: item.id,
              contentRank: index + this.qaList?.length,
            },
          };
        });
        this.qaList.push(...newResult);
        this.totalCount = totalCount;
        this.pageNum++;
        this.loading = false;
        if (this.pageNum > totalPages) {
          this.finished = true;
        }
        this.$nextTick(() => {
          this.$exposure.sensorsExposure();
        });
      } else {
        this.loading = false;
        this.jobError = true;
        // this.$toast.fail(res?.msg);
      }
    },
    async getCompanyInfo() {
      const { id, componentId } = this.queryData;
      const params = {
        companyIdList: [id],
        componentId,
      };
      const res = await this.$api.activity.getCompanyInfo(params);
      if (+res?.code == "0") {
        this.coInfo = res.data[0] || {};
      }
    },
    async getJobInfo() {
      const { id, componentId } = this.queryData;
      const params = {
        jobIdList: [id],
        componentId,
      };
      const res = await this.$api.activity.getJobInfo(params);
      if (+res?.code == "0") {
        this.jobInfo = res.data[0] || {};
      }
    },
  },
  async mounted() {
    const { type } = this.queryData;
    if (type == "2") {
      this.getCompanyInfo();
    } else if (type == "3") {
      this.getJobInfo();
    }
    this.getQuestionList();
    if(this.$store.state.commonStore.searchPage){
      this.stateHeight = '0px'
    }else{
      this.stateHeight = await this.$base.getAppStateHeight();
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped lang="less">
.empty {
  background-image: url("@/assets/img/activity/empty_type2@3x.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  .pc & {
    width: 375px;
    left: 50%;
    transform: translateX(-50%);
    background-size: contain;
  }
  &.type1 {
    background-image: url("@/assets/img/activity/empty_type1@3x.png");
  }
  .skeleton {
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0) 24%,
      rgba(255, 255, 255, 0.9) 25%,
      rgba(255, 255, 255, 0.9) 75%,
      rgba(255, 255, 255, 0) 76%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 50% 100%;
    filter: blur(25px);
    animation: gradient 1.5s linear infinite;
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: 100% 50%;
    }
  }
}
.qaList {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(
    180deg,
    rgba(255, 117, 29, 0.1) 0%,
    rgba(255, 255, 255, 0) 20%
  );
  box-sizing: border-box;
  .qaList_content_wrap {
    padding-bottom: 130px;
    padding-top: 48px;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    .answer_num {
      font-size: 14px;
      color: #ff6c0e;
      margin: 13px 0 10px 23px;
    }
    .qaList_header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 12px 20px;
      & > img {
        width: 102px;
        height: 25px;
      }
      & > div {
        display: flex;
        align-items: center;
        & > img {
          width: auto;
          height: 22px;
          margin-right: 5px;
        }
        & > span {
          font-size: 12px;
          color: #4e525a;
        }
      }
    }
    .empty_div_wrap {
      flex: 1;
      background: #ffffff;
      margin: 0 8px;
      display: flex;
      align-items: center;
      border-radius: 8px;
    }
  }
  .bottom_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 107px;
    background: #ffffff;
    .pc & {
      width: 375px;
      left: 50%;
      transform: translateX(-50%);
    }
    & > div {
      width: 343px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      background: #ff6c0e;
      border-radius: 4px;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      margin: auto;
      margin-top: 17px;
      cursor: pointer;
    }
  }
  .activity-header-container {
    position: relative;
    .activity-header {
      min-height: 44px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 999;
      .pc & {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 999;
        width: 375px;
      }
      .left {
        display: flex;
      }
      /deep/.van-nav-bar {
        height: 44px;
        width: 100%;
        .van-nav-bar__content {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 16px 0 16px;
          position: relative;
          .van-nav-bar__title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
          }
        }
      }
      .icon-back {
        display: inline-block;
        width: 24px;
        height: 24px;
      }
    }
  }
  .loading {
    text-align: center;
    // font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #000000;
    line-height: 18px;
    margin: 15px 0 25px 0;
  }
  /deep/ .van-list__loading {
    margin: 11px 0 27px 0;
    .van-loading--circular {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .van-loading__circular {
      display: none;
    }
    .van-loading__spinner--circular {
      height: 16px !important;
      display: block;
      width: 14px !important;
    }
    .van-loading__spinner--circular::after {
      content: "";
      background-image: url("~@/assets/img/activity/loading@2x.png");
      background-size: cover;
      height: 16px;
      display: block;
      width: 14px;
      background-repeat: no-repeat;
      animation: rotate 1.5s linear infinite;
    }
    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
    .van-loading__text {
      font-weight: 400;
      font-size: 13px;
      color: #4e4e4e;
      margin-left: 6px;
    }
  }
  /deep/ .van-list__error-text,
  /deep/ .van-list__finished-text,
  /deep/ .van-list__loading {
    color: #4e4e4e;
    text-align: center;
    margin: 11px 0 0px 0;
  }
}
</style>
